/**
 * Heuristics for the customer/supplier comboboxes, where the same free-text box
 * is searched against name, code, AND phone. When a search finds nothing and the
 * user clicks "Create", a phone-looking query should seed the Phone field — not
 * Name — so the typed number lands where it belongs.
 */

/** True when a typed search string looks like a phone number rather than a name. */
export function looksLikePhone(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  // Names contain letters; phone numbers don't.
  if (/[a-zA-Z]/.test(trimmed)) return false;
  // Only phone-ish characters allowed: digits, whitespace, and + - ( ) .
  if (!/^[0-9\s()+.-]+$/.test(trimmed)) return false;
  // Enough digits to be a real number (local 7, full 10+).
  return trimmed.replace(/\D/g, '').length >= 7;
}

/**
 * Split a combobox query into the field it should seed on the "create customer"
 * form: a phone-looking query seeds Phone (leaving Name for the user to fill in),
 * otherwise it seeds Name.
 */
export function seedCustomerFields(query: string): { name: string; phone: string } {
  const trimmed = query.trim();
  return looksLikePhone(trimmed) ? { name: '', phone: trimmed } : { name: trimmed, phone: '' };
}
